import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { usePlatformNavStore } from './usePlatformNavStore';

export interface User {
  id: string;
  email: string;
  name: string;
  role: 'admin' | 'user';
  /** 平台用户可为 null（与后端 Phase 15 一致） */
  tenantId: string | null;
  permissions?: string[];
  /** 有值时侧栏仅展示这些 path（仍与权限码求交）；未返回则仅按权限码 */
  menuKeys?: string[];
  userKind?: 'PLATFORM' | 'TENANT';
  scope?: 'platform' | 'tenant';
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  login: (user: User, token: string) => void;
  logout: () => void;
  updateUser: (user: Partial<User>) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      login: (user, token) => {
        console.log('Login called with user:', user);
        set({ user, token, isAuthenticated: true });
        console.log('State after login:', get());
      },
      logout: () => {
        console.log('Logout called');
        usePlatformNavStore.getState().reset();
        set({ user: null, token: null, isAuthenticated: false });
        console.log('State after logout:', get());
      },
      updateUser: (userData) =>
        set((state) => ({
          user: state.user ? { ...state.user, ...userData } : null,
        })),
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
      // 保存完整的 state
      partialize: (state) => {
        const persistedState = {
          user: state.user,
          token: state.token,
          isAuthenticated: state.isAuthenticated,
        };
        console.log('Persisting state:', persistedState);
        return persistedState;
      },
      onRehydrateStorage: () => {
        console.log('Rehydration started');
        return (state, error) => {
          if (error) {
            console.error('Rehydration failed:', error);
          } else {
            console.log('Rehydration successful, state:', state);
          }
        };
      },
    }
  )
);
